<script setup lang="ts">
import { Icon } from '@iconify/vue'
const emit = defineEmits(['clear'])

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<{ disabled?: boolean }>(), {
  disabled: false,
})
</script>

<template>
  <!-- File viewer style abstraction -->
  <div class="flex flex-col w-full h-[240px] overflow-clip rounded-b-lg">
    <!-- Header -->
    <div class="border p-4 pr-2 flex items-center gap-sm rounded-t-lg border-component-stroke-primary">
      <slot name="header" />
      <Icon
        v-if="!disabled"
        class="ml-auto cursor-pointer shrink-0 p-2"
        icon="mdi:close"
        height="32"
        @click="emit('clear')"
      />
    </div>
    <!-- Content underneath -->
    <div class="border border-component-stroke-primary h-full rounded-b-lg border-t-none">
      <slot />
    </div>
  </div>
</template>
